import { Route, Routes, useParams } from "react-router-dom";
import Blogs from "../../components/Blog/index.jsx";
import BlogDetail from "../../components/Blog/Detail.jsx";
import React from "react";

const BlogDetailPage = () => {
  const { id } = useParams();
  if (!id) return "NotFound";
  return <BlogDetail _id={id} />;
};
const BlogPage = () => {
  return (
    <Routes>
      <Route path="" element={<Blogs />} />
      <Route path=":id" element={<BlogDetailPage />} />
    </Routes>
  );
};

BlogPage.propTypes = {};

export default BlogPage;
